import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { AsyncStorage } from "jotai/vanilla/utils/atomWithStorage";

import { jotaiLocalStorage } from "./storage";

type UserSettings = {
  projectFilterStatus: string;
};

const userSettingsAtom = atomWithStorage<UserSettings | null>(
  "userSettings",
  null,
  jotaiLocalStorage as AsyncStorage<UserSettings | null>,
);

export const useUserSettings = () => {
  const [userSettings, setUserSettings] = useAtom(userSettingsAtom);
  return { userSettings, setUserSettings };
};
